export default __webpack_public_path__ + "static/media/content-2.24d3bf4f.jpg";